// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q25M4S8Cns2JH_8ENo7h{display:none}`, "",{"version":3,"sources":["webpack://./src/entities/Integrations/providers/Nango/NangoConnectButton/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA","sourcesContent":[".hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hidden": `Q25M4S8Cns2JH_8ENo7h`
};
export default ___CSS_LOADER_EXPORT___;
